import * as React from 'react';

import {deserializeFieldNames} from 'nutshell-core/entities/deserialize-fields';
import type {FilterObject} from 'nutshell-core/types';

import {LoadingPage} from 'shells/loading-page/loading-page';

import {getReportDefaultFields} from '../../../reports/report-constants';
import type {ReportURLParams} from '../../../reports/report-types';

import {FormRespondentsListContainer} from './form-respondents-list-container';

type Props = {
    formId: string | null | undefined;
    defaultFields: string[];
    numSubmissions: number;
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
    onRemoveAllFilters: () => void;
    customEmptyStateComponent: React.ReactNode;
};

export function FormRespondents(props: Props) {
    if (!props.formId) {
        return <LoadingPage />;
    }

    const listParams = props.urlParams.list || {};
    const listSelectedFields =
        // @ts-expect-error
        listParams.fields && listParams.fields.contacts
            ? // @ts-expect-error
              deserializeFieldNames(listParams.fields.contacts)
            : deserializeFieldNames(getReportDefaultFields('formEngagement'));

    const search = props.urlParams.q || '';

    return (
        <div className='routed-report-content' id='form-respondents-list'>
            <FormRespondentsListContainer
                formId={props.formId}
                defaultFields={props.defaultFields}
                filters={props.activeFilters}
                search={search}
                selectedPage={
                    // @ts-expect-error
                    listParams.page && Number(listParams.page) ? Number(listParams.page) : 1
                }
                unfilteredCount={props.numSubmissions}
                onRemoveAllFilters={props.onRemoveAllFilters}
                // @ts-expect-error
                selectedSortField={listParams.sort}
                selectedFields={listSelectedFields}
                onParamChange={props.onParamChange}
                urlParams={props.urlParams}
                customEmptyStateComponent={props.customEmptyStateComponent}
            />
        </div>
    );
}
